import { render } from "./ObserverBlock.vue?vue&type=template&id=a3be8658"
import script from "./ObserverBlock.vue?vue&type=script&lang=js"
export * from "./ObserverBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__